<template>
  <div v-if="value" class="common_dialog_bg">
    <div class="common_dialog" :class="size">
      <div class="header">
        <div class="title">
          <p>{{ title }}</p>
        </div>
        <IconClose v-show="needClose" class="close_btn" @click.native="close" />
      </div>
      <div class="dialog_content"><slot /></div>
    </div>
  </div>
</template>

<script>
import IconClose from '@/components/Icons/IconClose.vue'

export default {
  name: 'Dialog',

  components: { IconClose },

  props: {
    title: {
      type: String,
      default: '提示'
    },

    value: {
      type: Boolean,
      required: true
    },

    size: {
      type: String,
      default: 'small'
    },

    needClose: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    close () {
      this.$emit('input', false)
      this.$emit('close', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.common_dialog_bg{
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.4);

  .common_dialog {
    position: absolute;
    top: 40%;
    left: 50%;
    z-index: 10;
    display: flex;
    flex-direction: column;
    width: 398px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: $box_shadow_1;

    &.mini { height: 120px;  transform: translate(-199px, -60px) }
    &.small { height: 164px; transform: translate(-199px, -82px) }
    &.small211 { height: 210px; transform: translate(-199px, -105px) }
    &.middle { height: 258px; transform: translate(-199px,  -129px); }

    .header { display: flex; justify-content: space-between; height: 30px; padding: 0 10px; border-bottom: 1px solid rgba(222, 222, 222, 0.6); }
    .title { display: flex; align-items: center; font-size: 14px; line-height: 30px; color: $font_color_8; }
    .close_btn { line-height: 30px; }

    .dialog_content { position: relative; flex: 1; }
  }
}

</style>
